export default "__VITE_ASSET__C1WVn7pb__"